import { render, staticRenderFns } from "./group-user.vue?vue&type=template&id=08b66908&scoped=true&"
import script from "./group-user.vue?vue&type=script&lang=js&"
export * from "./group-user.vue?vue&type=script&lang=js&"
import style0 from "./group-user.vue?vue&type=style&index=0&id=08b66908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b66908",
  null
  
)

export default component.exports